import Request from '@/plugins/request';

export function getRebateLogs(params) {
  return Request.get('rebate-logs', { params })
}

export function createRebateLog() {
  return Request.get(`rebate-logs/create`)
}

export function storeRebateLog(data) {
  return Request.post('rebate-logs', data)
}

export function updateRebateLog(id, data) {
  return Request.put(`rebate-logs/${id}`, data)
}

export function editRebateLog(id) {
  return Request.get(`rebate-logs/${id}/edit`)
}

export function destroyRebateLog(id) {
  return Request.delete(`rebate-logs/${id}`)
}
